module.exports = __webpack_public_path__ + "static/sui-button-social-12c2a75a4d5b444ee772622e1655e394.png";